import React from 'react';
import { BAR_COUNT, Bar, Container } from './LoadingWave.style';

interface Props {
  color?: string;
  size?: number;
}

const LoadingWave: React.FC<Props> = ({ color, size = 32 }) => {
  return (
    <Container $size={size} data-testid="loading-wave">
      {Array.from({ length: BAR_COUNT }).map((_bar, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Bar key={index} $size={size} $color={color} $index={index} />
      ))}
    </Container>
  );
};

export default LoadingWave;
